import {ViewAttachmentComponent} from '../shared/components/pdf-viewer/view-attachment/view-attachment.component';
import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {OpenDialog} from '../interfaces/global.interface';
import {Apollo} from 'apollo-angular';
// import { AppState } from '../store/reducers';
import {NgxPermissionsService} from 'ngx-permissions';
import {NotificationService} from './notification.service';
import {StorageService} from './storage.service';
import {Workbook} from 'exceljs';
import * as fs from 'file-saver';
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {lastValueFrom} from "rxjs";
import {Translation} from "../store/entities/system-settings/translation/translation.model";
import {Store} from "@ngrx/store";
import {AppState} from "../store/reducers";
import {selectAllTranslations} from "../store/entities/system-settings/translation/translation.selectors";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private dialogRefs = new Map<any, MatDialogRef<any>>();

  constructor(
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private router: Router,
    private store: Store<AppState>,
    private translate: TranslateService,
  ) { }

  formatDateWithForwardSlash(date: Date) {
    return this.datePipe.transform(date, 'dd/MM/yyyy');
  }

  formatDate(date, format: string = 'dd/MM/yyyy'): string {
    return this.datePipe.transform(date, format);
  }

  formatDateWithHyphen(date): string {
    return this.datePipe.transform(date, 'dd-MM-yyyy');
  }

  formatDateWithHyphenStartYear(date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }


  nullChecker(value: any) {
    return !value ? '_' : value;
  }


  validDateformatByDayMonthYear(input) {
    const str = input;

    const [day, month, year] = str.split('/');

    // console.log(month); // 👉️ "07"
    // console.log(day); // 👉️ "21"
    // console.log(year); // 👉️ "2024"

    const theValidDate = new Date(+year, +month - 1, +day);

    // console.log(date)
    return this.datePipe.transform(theValidDate, 'yyyy-MM-dd')
  }

  b64toBlob(b64Data, contentType, sliceSize = 512) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return URL.createObjectURL(blob);
  }


  encode(data, loop = 2, key = 'secured'): string {
    let returnedData = btoa(data);
    const keyValue = btoa(key);
    returnedData = btoa(keyValue + returnedData);
    for (let i = 0; i < loop; i++) {
      returnedData = btoa(returnedData);
    }
    return returnedData;
  }

  decode(data, loop = 2, key = 'secured') {
    let returnedData = data;

    for (let i = 0; i < loop; i++) {
      returnedData = atob(returnedData);
    }
    const keyValue = btoa(key);
    returnedData = atob(returnedData);

    return atob(returnedData.substr(keyValue.length));
  }

  openDialogModal(dialog: OpenDialog) {
    const dialogConfig = new MatDialogConfig();
    const classes: string[] = [];
    if (dialog?.panelClass?.length > 0) {
      classes.push(...dialog?.panelClass);
    }
    dialogConfig.panelClass = classes;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = dialog?.width ? dialog?.width : '50%';
    dialogConfig.data = dialog?.data;
    if (dialog?.position != null) {
      dialogConfig.position = dialog?.position;
    }
    if (dialog?.height != null) {
      dialogConfig.height = dialog?.height;
    }
    return this.dialog.open(dialog?.component, dialogConfig);
  }

  closeDialog<T>(component: T): void {
    const dialogRef = this.dialogRefs.get(component);
    if (dialogRef) {
      dialogRef.close();
      this.dialogRefs.delete(component);
    }
  }

  closeAllDialog(): void {
    for (const dialogRef of this.dialogRefs.values()) {
      dialogRef.close()
    }
  }

  loadTranslation(){

    this.store.select(selectAllTranslations).subscribe((translations: Translation[]) => {
      if (translations){

        const enObj = {};
        const swObj = {};

        translations?.forEach( (translation) => {
          if (enObj[translation?.keyword]){
            // console.log('English translation with keyword ', translation?.keyword, ' already exist');
          }else {
            Object.defineProperty(enObj, translation?.keyword , {value : translation?.en});
          }
        });

        translations?.forEach( (translation) => {
          if (swObj[translation?.keyword]){
            // console.log('Swahili translation with keyword ', translation?.keyword, ' already exist');
          }else {
            Object.defineProperty(swObj, translation?.keyword , {value : translation?.sw});
          }
        });


        this.translate.setTranslation('en', enObj);
        this.translate.setTranslation('sw', swObj);
      }
    })

    lastValueFrom(
      this.store.select(selectAllTranslations)
    ).then( (translations: Translation[]) => {

      console.log('---')

    });
  }


  sanitizeBase64(data) {
    return data.toString().replaceAll("b'", '').replaceAll("'", '')
  }



  reloadCurrentRoute(currentUrl) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    currentUrl = currentUrl === null ? this.router.url : currentUrl;
    this.router.navigate([currentUrl]);
  }

  generatePagination(current: number, lastPage: number) {
    // return  Array((totalPages === 1) ? 1 : totalPages).fill(0).map((x, i) => ({id: i}));
    const delta = 6;
    const range = [0];
    const rangeWithDots = [];
    let l;

    range.push(1);
    for (let i = current - delta; i <= current + delta; i++) {
      if (i < lastPage && i > 1) {
        range.push(i);
      }
    }
    range.push(lastPage);

    for (const i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }
    return rangeWithDots;
  }

  async viewFile(base64string, fileFormat, name = null) {
    const dialogRef = this.dialog.open(ViewAttachmentComponent, {
      width: '80%',
      data: {
        base64: base64string,
        format: fileFormat,
        name,
      },
    });

    return dialogRef.afterClosed().toPromise();
  }


  isNullOrUndefined(value: any) {
    return value === 'undefined' || value === 'null' || value === undefined || typeof value === 'undefined' || value === null || Number.isNaN(value)
      || (typeof value === 'object' && Object.keys(value).length === 0) || (typeof value === 'string' && value.trim().length === 0);

  }

  isArray = (val: any) => {
    if (val === null) {
      return false;
    }
    return Object.prototype.toString.call(val) === '[object Array]';
  }


  sortArray(array: any[], property: any, order: 'ASC' | 'DESC'): any[] {
    try {
      if (array === null || property === null) {
        return array;
      }
      const pos = order === 'ASC' ? 1 : -1;
      const neg = order === 'ASC' ? -1 : 1;
      return array.slice().sort((firstEl, secondEl) => {
        if (firstEl[property] < secondEl[property]) {
          return neg;
        }
        if (firstEl[property] > secondEl[property]) {
          return pos;
        }
        return 0;
      });
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  formatDateMonthName(date): string {
    return this.datePipe.transform(date, 'mediumDate');
  }


  exportExcel(data, columns, fileName = "Report", sheetName = "data") {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(sheetName);

    worksheet.columns = columns;

    data.forEach(e => worksheet.addRow(e, "n"));

    data.forEach((row, index) => {
      if (index % 2 == 0) return

      worksheet.getRow(index + 2).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'eeeeee' }
      }
    });

    worksheet.getRow(1).font = { name: 'calibri', size: 14, bold: true, };

    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'cccccc' }
    }

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, fileName + '.xlsx');
    })

  }


  sanitizeFormData(formData) {
    Object.keys(formData).forEach(key => formData[key] = formData[key] == 'None' ? null : formData[key]);
    return formData;
  }


  enumToArray(enumme) {
    return Object.keys(enumme)
      .map(key => ({ name: enumme[key], value: key }))
  }

  formatNumberWithCommas(x: { toString: () => string; }) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  concatEngSw(en: string, sw: string): string {
    return `[en]${en}[/en][sw]${sw}[/sw]`
  }

  splitEngSw(value: string): { en: string, sw: string } {
    return {
      en: value?.match(/\[en](.*?)\[\/en]/)?.[1] || value?.match(/\[EN](.*?)\[\/EN]/)?.[1] || null,
      sw: value?.match(/\[sw](.*?)\[\/sw]/)?.[1] || value?.match(/\[SW](.*?)\[\/SW]/)?.[1] || null
    }
  }


}
